// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const configDefault = {
  versionName: "2.3.4",
  urlAppAndroid: "https://play.google.com/store/apps/details?id=br.com.phicubeapp",
  urlAppIos: "https://apps.apple.com/br/app/phicube/id1475419152",
  clientId: 2,
  clientSecret: 'xW6OYNNm1lqAQDtVp5kK0jEMiAzAoaZZOYgEeZU4'
}

const desenv = {
  production: false,
  urlWebsocket: "wss://phicube.blackwallet.com.br:6001",
  pathToMobile: 'https://phicube.blackwallet.com.br',
  pathToWeb: 'https://phicube.blackwallet.com.br',
  ...configDefault
};

const prod = {
  production: true,
  urlWebsocket: "wss://app.phicube.com.br:6001",
  pathToMobile: 'https://app.phicube.com.br',
  pathToWeb: 'https://app.phicube.com.br',
  ...configDefault
};

export const environment = prod;

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
    